import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { PasswordResetActions } from 'Redux/modules/passwordReset/actions';
import { PasswordResetSelectors } from 'Redux/modules/passwordReset/selectors';
import AppConfig from 'Config/AppConfig';
import c from '../../../Components/AuthLayout/authContent.module.less';

const CONTACT_EMAIL = 'support@pipl.com';

// Ported from accounts/templates/pages/password_reset/password_reset_sent.html
// Shows "check your email" confirmation; includes a RESEND button that re-submits
// the same email + a fresh captcha token.
function ResetSent({ email }) {
  const dispatch = useDispatch();
  const isSubmitting = useSelector(PasswordResetSelectors.passwordResetIsSubmittingSelector);
  const [captchaToken, setCaptchaToken] = React.useState(null);
  const [resent, setResent] = React.useState(false);

  const handleResend = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setResent(true);
    dispatch(PasswordResetActions.requestReset({ email, captcha: captchaToken }));
  };

  return (
    <>
      <h1 className={c.title}>Check your email</h1>

      {!resent ? (
        <>
          <p className={c.text}>
            We sent a password reset email — you should receive it momentarily. If it doesn&apos;t arrive within a few
            minutes, resend below or contact us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
          <form onSubmit={handleResend}>
            <div className={c.captcha}>
              <ReCAPTCHA
                sitekey={AppConfig.RECAPTCHA_KEY || (window.__CONFIG__ && window.__CONFIG__.RECAPTCHA_KEY) || ''}
                onChange={(token) => setCaptchaToken(token)}
              />
            </div>
            <button type="submit" name="resend" className={c.btnPrimary} disabled={isSubmitting}>
              Resend email
            </button>
          </form>
        </>
      ) : (
        <p className={c.text}>
          We have resent the password email. If it doesn&apos;t arrive within a few minutes, contact us at{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
      )}
    </>
  );
}

export default ResetSent;
